// extracted by mini-css-extract-plugin
export default {"form":"viewQuiz_form__Tx92t","addButton":"viewQuiz_addButton__AlnhM","backButton":"viewQuiz_backButton__mF7qD"};